/**
 * @Author: v_jppjpeng
 * @Date: 2025-04-29 11:41:27
 * @Explain: 处理common相关逻辑
 */

// utils
import { getImgUrl, getLocationQuery, onSplitData } from '@/utils/common';
import {
  getLocalStorage,
  getSessionStorage,
  jsonParse,
  setSessionStorage,
} from '@/utils/global';
// type
import {
  BusinessListItemIF,
  RoleCodeEnum,
  RoleListItemIF,
} from '@/api/common/data.d';
import { StoreKeyEnum } from '@/definition/common/data.d';
import { defaultBusiness } from '../config/common';
import { UserAuthResData } from '../typing/common';

// 获取简写语言
export const getAbbreviationLang = (localLanguage: string) => {
  return onSplitData(localLanguage, '-',)[0];
}

// 获取业务信息列表
export const getBusinessList = (resData: UserAuthResData) => {
  const { roleInfo, businessList } = resData;
  return (
    businessList?.map((item) => ({
      ...item,
      iconUrl: item.iconUrl,
      // iconUrl: item.iconUrl || getImgUrl('businessLogo.webp'),
      roles: getRole(roleInfo, item.gameId),
      // 特殊逻辑 - 29162 不展示
      isAuthorize: item.gameId === 29162 ? 1 : item.isAuthorize,
    })) || []
  );
};

// 获取当前业务信息
export const getCurrentBusinessItem = ({
  businessList,
  accountId,
}: {
  businessList: BusinessListItemIF[];
  accountId: string;
}) => {
  const linkGameId = +getLocationQuery('gameId');
  // 当前业务项信息
  let currentBusinessItem = businessList?.[0] || {};
  // 其它途径跳转至系统 - 业务ID
  const jumpHereGameId =
    +getLocationQuery('gameId') || +getSessionStorage(StoreKeyEnum.GAME_ID);
  // 本地存储选中的业务
  const currentBusinessStore: BusinessListItemIF = jsonParse(
    getLocalStorage((StoreKeyEnum.CURRENT_BUSINESS + accountId) as any) ||
      getLocalStorage(StoreKeyEnum.CURRENT_BUSINESS),
  );

  // 其它途径跳转至系统 - url上携带业务ID
  if (linkGameId) {
    setSessionStorage({
      name: StoreKeyEnum.GAME_ID,
      content: linkGameId,
    });
  }

  if (jumpHereGameId) {
    currentBusinessItem = businessList.filter(
      (item) => item.gameId === jumpHereGameId,
    )?.[0] || { ...defaultBusiness, gameId: linkGameId, jumpHereGameId };
  } else if (currentBusinessStore?.gameId) {
    let currentGameId = currentBusinessStore.gameId;
    // 获取的业务列表 - 是否存在当前选中业务
    const isSelectedBusiness = currentGameId
      ? businessList.findIndex((item) => item.gameId === currentGameId) !== -1
      : false;
    currentBusinessItem = isSelectedBusiness
      ? businessList.filter((item) => item.gameId === currentGameId)?.[0]
      : businessList?.[0];
  }
  return currentBusinessItem;
};

// 获取角色信息
export const getRole = (data: RoleListItemIF[], gameId: number) => {
  const list: any[] = [];
  data?.forEach((item) => {
    if (item.gameId === gameId) {
      list.push(item.roleCode);
      // 开启Conversion数据查看角色权限，收集此角色
      if (!!item?.isGameDataAdmin) {
        list.push(RoleCodeEnum.GAME_DATA_ADMIN);
      }
    }
    // 如果有运营角色直接加在角色上
    if (item.roleCode === RoleCodeEnum.OPERATOR) {
      list.push(item.roleCode);
    }
  });
  return list;
};
// 处理用户角色信息
const handledUserRole = () => {};
